export const DOCUMENT_ICON = {
  ANNOTATE: "annotation-filled",
  ANNOTATE_LINE: "annotation-line",
  ESIGN: "esign",
  IN_MEETING: "sign-meeting-on",
  IN_MEETING_LINE: "sign-meeting-off",
  NOTARIZATION: "notarize-filled",
  PROOFING: "account-setup",
  WET_SIGN: "wetsign-on",
  WET_SIGN_LINE: "wetsign-off",
  WITNESS: "witness-filled",
  WITNESS_LINE: "witness-line",
  SECURE: "secure",
};
